// src/contexts/AlertContext.js

import React, { createContext, useState } from "react";

// Gumawa ng Context
export const AlertContext = createContext();

// Gumawa ng Provider Component
export const AlertProvider = ({ children }) => {
  // Estado para sa alert
  const [alert, setAlert] = useState(null); // { type: 'success' | 'danger', message: string }

  // Function para ipakita ang alert
  const showAlert = (type, message, duration = 3000) => {
    setAlert({ type, message });

    // Awtomatikong itago ang alert pagkatapos ng duration
    setTimeout(() => {
      setAlert(null);
    }, duration);
  };

  // Function para itago ang alert manually
  const hideAlert = () => {
    setAlert(null);
  };

  return (
    <AlertContext.Provider value={{ alert, showAlert, hideAlert }}>
      {children}
    </AlertContext.Provider>
  );
};
